import React from "react";
import { COLORS } from "../constants/colors";
import Seo from "../components/Seo";
import "./About.css";

function About() {
  return (
    <div className="about-container">
      <Seo title="About — BudgetMate" description="About BudgetMate — a simple, secure, and smart budgeting app." />
      <section className="about-header">
        <h1 style={{ color: COLORS.primary }}>About BudgetMate</h1>
        <p className="subtitle">
          Simple. Secure. Smart budgeting for everyone.
        </p>
      </section>

      <section className="about-card">
        <h2>What is BudgetMate?</h2>
        <p>
          <strong>BudgetMate</strong> is a smart budget and expense tracking
          application designed to help individuals manage their income,
          expenses, and savings in a simple and organized way.
        </p>

        <p>
          The app focuses on clarity and control — allowing users to understand
          where their money goes and make better financial decisions without
          complexity.
        </p>

        <h2>Why BudgetMate?</h2>
        <ul>
          <li>Easy tracking of daily expenses and income</li>
          <li>Clear summaries and visual insights</li>
          <li>Clean and user-friendly interface</li>
          <li>Privacy-focused and secure data handling</li>
        </ul>

        <h2>Our Mission</h2>
        <p>
          Our mission is to empower users with simple tools that encourage
          financial awareness and disciplined money management — without
          stress or confusion.
        </p>

        <h2>Who Can Use It?</h2>
        <p>
          BudgetMate is built for students, professionals, freelancers, and
          anyone who wants better control over personal finances.
        </p>

        <h2>Contact & Support</h2>
        <p>
          If you have questions, feedback, or need support, feel free to reach
          out to us:
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:budgetmate1.app@zohomail.in">
            budgetmate1.app@zohomail.in
          </a>
        </p>
      </section>
    </div>
  );
}

export default About;
